module.exports = __webpack_public_path__ + "static/media/arrowLeft.83fac6da.svg";